import ScrollProgress from './components/ScrollProgress';
import Hero from './components/Hero';
import Quote from './components/Quote';
import Showcase from './components/Showcase';
import Expertise from './components/Expertise';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Dock from './components/Dock';

export default function App() {
  return (
    <>
      <ScrollProgress />
      <main>
        <Hero />
        <Quote />
        <Showcase />
        <Expertise />
        <Contact />
      </main>
      <Footer />
      <Dock />
    </>
  );
}
